import graphql from "babel-plugin-relay/macro";
import { usePaginationFragment } from "react-relay";

import { FeaturedEventsScroller } from "./FeaturedEventsScroller";
import { FeaturedEventsDepartmentFragment$key } from "./__generated__/FeaturedEventsDepartmentFragment.graphql";

type FeaturedEventsDepartmentProps = {
  nodeRef: FeaturedEventsDepartmentFragment$key;
};

export const FeaturedEventsDepartment = ({
  nodeRef,
}: FeaturedEventsDepartmentProps) => {
  const { data, loadNext, hasNext, isLoadingNext } = usePaginationFragment(
    FeaturedEventsDepartmentFragmentString,
    nodeRef
  );

  return (
    <FeaturedEventsScroller
      nodeRef={data.events ?? null}
      hasNext={hasNext}
      isLoadingNext={isLoadingNext}
      loadNext={loadNext}
    />
  );
};

const FeaturedEventsDepartmentFragmentString = graphql`
  fragment FeaturedEventsDepartmentFragment on Department
  @refetchable(queryName: "FeaturedEventsDepartmentEventsPaginationQuery") {
    events(
      first: $count
      after: $cursor
      dateGte: $startDate
      dateLte: $endDate
      isFeatured: true
      tagIds: $eventTags
    ) @connection(key: "FeaturedEventsFragment_events") {
      count
      edges {
        node {
          id
        }
      }
      ...FeaturedEventsScrollerEventConnection
    }
  }
`;
